import { LocalTaxonomy } from './taxonomy.model';

export const TAXONOMY_FILTER_VALUES = [
  { label: 'All Taxonomies', value: 'all' },
  // { label: 'Published', value: 'published' },
  { label: 'Draft', value: 'draft' },
];

export const TAXONOMY_CARD_DUMMY_DATA: Array<LocalTaxonomy> = [];

export const EmptySelectionTaxonomy: LocalTaxonomy = {
  taxonomy_id: '',
  taxonomy_name: '',
  taxonomy_description: '',
  created_on: '',
  linked_queue_groups: [],
  version_id: '',
  version_status: '',
  version_created_on: '',
  version_created_by: '',
  version_updated_on: '',
  version_updated_by: '',
  version_history_details: [],
  selected_taxonomy_version: {},
};

export const TaxonomyTypes = [
  {
    label: 'Primary Topic',
    value: 'Primary Topic',
  },
];

export const TaxonomyFilterContent = [
  {
    label: 'All Entities',
    value: 'all',
  },
];
